<template>
  <div class="quick-choice-page">
    <div class="create-box">
      <div class="title">号码生成区</div>
      <div
        class="create-content"
        v-if="htmlData !== ''"
        v-html="htmlData"
      ></div>
      <div
        class="create-content"
        style="
          background: transparent;
          display: flex;
          align-items: center;
          justify-content: center;
        "
        v-else
      >
        <div class="noData"></div>
      </div>
      <div
        class="title"
        style="
          background: var(--new-bg-primary);
          color: var(--new-text-primary-bg);
        "
      >
        投注区
      </div>
      <div class="bottom-tool">
        <div class="left">
          <span class="active-text bold">下注金额：</span>
          <input
            type="text"
            class="money input"
            ref="money"
            v-model="money"
            @keyup.enter="submit()"
          />
          <input
            type="button"
            class="btn primary"
            value="提交"
            @click="submit()"
          />
        </div>
        <div class="right">
          <span class="">笔数：</span>
          <span class="totalNum red">
            {{ totalNum }}
          </span>
          <span class="">金额：</span>
          <span class="totalMoney red">
            {{ totalMoney }}
          </span>
        </div>
      </div>
    </div>
    <div class="tool-panel">
      <ul class="nav">
        <li
          @click="choiceType = 'D2W'"
          :class="{ active: choiceType === 'D2W' }"
        >
          二字定
        </li>
        <li
          @click="choiceType = 'D3W'"
          :class="{ active: choiceType === 'D3W' }"
        >
          三字定
        </li>
        <li
          @click="choiceType = 'D4W'"
          :class="{ active: choiceType === 'D4W' }"
        >
          四字定
        </li>
      </ul>
      <table
        id="kx_content"
        style="width: 100%"
        @keyup.enter="create()"
        cellpadding="0"
        cellspacing="0"
      >
        <tr class="position-filter">
          <td colspan="10">
            <div style="display: flex; align-items: center">
              <span style="margin-left: 50px" class="active-text active-text"
                >定位置</span
              >&nbsp;&nbsp;
              <input
                style="margin: 0 5px"
                class="checkbox"
                type="checkbox"
                positiontype="0"
                positionfilter="1"
              />
              除&nbsp;&nbsp;
              <input
                style="margin: 0 5px"
                type="checkbox"
                class="initChecked checkbox"
                positiontype="0"
                positionfilter="0"
                checked
              />
              取
            </div>
          </td>
          <td class="bc" colspan="10">
            <div style="display: flex; align-items: center">
              <span style="margin-left: 50px" class="active-text active-text"
                >配速全转</span
              >&nbsp;&nbsp;
              <input
                style="margin: 0 5px"
                class="checkbox"
                type="checkbox"
                positiontype="1"
                positionfilter="1"
              />
              除&nbsp;&nbsp;
              <input
                style="margin: 0 5px"
                class="checkbox"
                type="checkbox"
                positiontype="1"
                positionfilter="1"
              />
              取
            </div>
          </td>
        </tr>
        <tr>
          <td colspan="20" style="border-bottom: 1px solid var(--new-border)">
            <div
              id="wwrdPnode"
              style="text-align: center"
              class="wwrdPnode"
              v-show="choiceType !== 'D4W'"
            >
              <div
                style="
                  display: flex;
                  justify-content: center;
                  align-items: center;
                "
              >
                <input
                  style="margin: 0 5px"
                  class="checkbox"
                  type="checkbox"
                  name="dw5zi"
                  id="wwrd"
                />
                {{ choiceType === "D2W" ? "五位二定" : "五位三定" }}
              </div>
            </div>
            <div
              style="
                display: flex;
                align-items: center;
                justify-content: center;
              "
              v-if="choiceType === 'D4W'"
            >
              <input
                style="margin: 0 5px"
                name="dw5zi"
                data-index="5"
                class="zdz initChecked checkbox"
                type="checkbox"
                checked
              />
              一五四定 &nbsp;&nbsp;
              <input
                style="margin: 0 5px"
                name="dw5zi"
                data-index="4"
                class="zdz checkbox"
                type="checkbox"
              />
              二五四定 &nbsp;&nbsp;
              <input
                style="margin: 0 5px"
                name="dw5zi"
                data-index="3"
                class="zdz checkbox"
                type="checkbox"
              />
              三五四定 &nbsp;&nbsp;
              <input
                style="margin: 0 5px"
                name="dw5zi"
                data-index="2"
                class="zdz checkbox"
                type="checkbox"
              />
              四五四定 &nbsp;&nbsp;
              <input
                style="margin: 0 5px"
                name="dw5zi"
                data-index="1"
                class="zdz checkbox"
                type="checkbox"
              />
              五五四定
            </div>
          </td>
        </tr>
        <tr class="match-input" v-show="showPeiSu">
          <td colspan="20">
            <input style="width: 88px; height: 22px" type="text" name="pei1" />
            配
            <input style="width: 88px; height: 22px" type="text" name="pei2" />
            <template v-if="choiceType === 'D3W' || choiceType === 'D4W'">
              配
              <input
                style="width: 88px; height: 22px"
                type="text"
                name="pei3"
              />
            </template>
            <template v-if="choiceType === 'D4W'">
              配
              <input
                style="width: 88px; height: 22px"
                type="text"
                name="pei4"
              />
            </template>
          </td>
        </tr>
        <tr v-show="!showPeiSu">
          <td colspan="20">
            <div
              style="
                display: flex;
                justify-content: space-around;
                align-items: center;
              "
            >
              <div
                style="
                  display: flex;
                  flex-direction: column;
                  align-items: center;
                "
              >
                <span>千</span>
                <input
                  class="input left"
                  type="text"
                  name="wan"
                  style="width: 85px; height: 22px"
                />
              </div>
              <div
                style="
                  display: flex;
                  flex-direction: column;
                  align-items: center;
                "
              >
                <span>百</span>
                <input
                  class="input left"
                  type="text"
                  name="qian"
                  style="width: 85px; height: 22px"
                />
              </div>
              <div
                style="
                  display: flex;
                  flex-direction: column;
                  align-items: center;
                "
              >
                <span>十</span>
                <input
                  class="input left"
                  type="text"
                  name="bai"
                  style="width: 85px; height: 22px"
                />
              </div>
              <div
                style="
                  display: flex;
                  flex-direction: column;
                  align-items: center;
                "
              >
                <span>个</span>
                <input
                  class="input left"
                  type="text"
                  name="shi"
                  style="width: 85px; height: 22px"
                />
              </div>
              <div
                style="
                  display: flex;
                  flex-direction: column;
                  align-items: center;
                "
              >
                <span>尾</span>
                <input
                  class="input left"
                  type="text"
                  name="ge"
                  style="width: 85px; height: 22px"
                />
              </div>
            </div>
          </td>
        </tr>
        <tr class="hefen-filter">
          <td class="bc hefen-filter center" colspan="20">
            <div
              style="
                display: flex;
                justify-content: center;
                align-items: center;
              "
            >
              <span class="active-text">合分</span>&nbsp;&nbsp;&nbsp;
              <input
                style="margin: 0 5px"
                class="checkbox"
                type="checkbox"
                hefentype="1"
              />&nbsp;&nbsp;除&nbsp;&nbsp;&nbsp;
              <input
                style="margin: 0 5px"
                class="initChecked checkbox"
                type="checkbox"
                hefentype="0"
                checked
              />&nbsp;&nbsp;取
            </div>
          </td>
        </tr>
        <tr>
          <td colspan="4" class="hefen-filter-item center">
            <div style="white-space: nowrap; line-height: 20px">
              1.
              <input class="checkbox" type="checkbox" name="" id="" />&nbsp;
              <input class="checkbox" type="checkbox" name="" id="" />&nbsp;
              <input class="checkbox" type="checkbox" name="" id="" />&nbsp;
              <input class="checkbox" type="checkbox" name="" id="" />&nbsp;
              <input class="checkbox" type="checkbox" name="" id="" />
            </div>
            <div style="line-height: 20px">
              <input
                class="input left"
                style="width: 90px; height: 22px"
                type="text"
              />
            </div>
          </td>
          <td colspan="4" class="hefen-filter-item center">
            <div style="white-space: nowrap; line-height: 20px">
              2.
              <input class="checkbox" type="checkbox" name="" id="" />&nbsp;
              <input class="checkbox" type="checkbox" name="" id="" />&nbsp;
              <input class="checkbox" type="checkbox" name="" id="" />&nbsp;
              <input class="checkbox" type="checkbox" name="" id="" />&nbsp;
              <input class="checkbox" type="checkbox" name="" id="" />
            </div>
            <div style="margin-top: 5px; line-height: 20px">
              <input
                class="input left"
                style="width: 90px; height: 22px"
                type="text"
              />
            </div>
          </td>
          <td colspan="4" class="hefen-filter-item center">
            <div style="white-space: nowrap; line-height: 20px">
              3.
              <input class="checkbox" type="checkbox" name="" id="" />&nbsp;
              <input class="checkbox" type="checkbox" name="" id="" />&nbsp;
              <input class="checkbox" type="checkbox" name="" id="" />&nbsp;
              <input class="checkbox" type="checkbox" name="" id="" />&nbsp;
              <input class="checkbox" type="checkbox" name="" id="" />
            </div>
            <div style="margin-top: 5px; line-height: 20px">
              <input
                class="input left"
                style="width: 90px; height: 22px"
                type="text"
              />
            </div>
          </td>
          <td colspan="4" class="hefen-filter-item center">
            <div style="white-space: nowrap; line-height: 20px">
              4.
              <input class="checkbox" type="checkbox" name="" id="" />&nbsp;
              <input class="checkbox" type="checkbox" name="" id="" />&nbsp;
              <input class="checkbox" type="checkbox" name="" id="" />&nbsp;
              <input class="checkbox" type="checkbox" name="" id="" />&nbsp;
              <input class="checkbox" type="checkbox" name="" id="" />
            </div>
            <div style="margin-top: 5px; line-height: 20px">
              <input
                class="input left"
                style="width: 90px; height: 22px"
                type="text"
              />
            </div>
          </td>
          <td colspan="4" class="hefen-filter-item center">
            <div style="white-space: nowrap; line-height: 20px">
              5.
              <input class="checkbox" type="checkbox" name="" id="" />&nbsp;
              <input class="checkbox" type="checkbox" name="" id="" />&nbsp;
              <input class="checkbox" type="checkbox" name="" id="" />&nbsp;
              <input class="checkbox" type="checkbox" name="" id="" />&nbsp;
              <input class="checkbox" type="checkbox" name="" id="" />
            </div>
            <div style="margin-top: 5px; line-height: 20px">
              <input
                class="input left"
                style="width: 95px; height: 22px"
                type="text"
              />
            </div>
          </td>
        </tr>
        <tr>
          <td class="bc budinghe-filter" colspan="7">
            <div style="display: flex; align-items: center">
              <span style="margin-left: 10px" class="active-text"
                >不定位合分</span
              >&nbsp;&nbsp;
              <input
                style="margin: 0 5px"
                class="checkbox"
                type="checkbox"
                budinghetype="2"
              />
              两数和
              <span
                style="display: flex; align-items: center"
                v-show="choiceType !== 'D2W'"
              >
                <input
                  style="margin: 0 5px"
                  class="checkbox"
                  type="checkbox"
                  budinghetype="3"
                />
                三数和
              </span>
            </div>
          </td>
          <td
            :colspan="choiceType === 'D4W' ? '4' : '13'"
            style="text-align: left; padding-left: 5px"
          >
            <input
              class="input left"
              style="width: 100px; height: 22px"
              type="text"
              maxlength="10"
            />
          </td>
          <td colspan="3" class="bc" v-show="choiceType === 'D4W'">
            <span class="active-text"> 值范围从 </span>
          </td>
          <td colspan="6" v-show="choiceType === 'D4W'">
            <input
              class="input left"
              style="width: 60px; height: 22px"
              name="zhifanwei1"
              type="text"
            />
            至
            <input
              class="input left"
              style="width: 60px; height: 22px"
              name="zhifanwei2"
              type="text"
            />
          </td>
        </tr>
        <tr>
          <td class="bc" colspan="2">
            <span style="margin-left: 10px" class="active-text">全转</span>
          </td>
          <td colspan="3">
            <input
              class="input left"
              style="width: 80px; height: 22px"
              name="quanzhuan"
              type="text"
            />
          </td>
          <td class="bc" colspan="2">
            <span class="active-text" style="white-space: nowrap">上奖</span>
          </td>
          <td colspan="3">
            <input
              class="input left"
              style="width: 80px; height: 22px"
              name="shangjiang"
              type="text"
            />
          </td>
          <td class="bc" colspan="2">
            <span class="active-text">排除</span>
          </td>
          <td colspan="3">
            <input
              class="input left"
              style="width: 80px; height: 22px"
              name="paichu"
              type="text"
            />
          </td>
          <td class="bc" colspan="2">
            <span class="active-text" v-show="choiceType !== 'D4W'"
              >乘号位置</span
            >
          </td>
          <td colspan="3">
            <span v-show="choiceType !== 'D4W'">
              <input
                style="margin: 0 2px"
                type="checkbox"
                class="symbol-filter-item checkbox"
                name="0"
              />
              <input
                style="margin: 0 2px"
                type="checkbox"
                class="symbol-filter-item checkbox"
                name="1"
              />
              <input
                style="margin: 0 2px"
                type="checkbox"
                class="symbol-filter-item checkbox"
                name="2"
              />
              <input
                style="margin: 0 2px"
                type="checkbox"
                class="symbol-filter-item checkbox"
                name="3"
              />
              <input
                style="margin: 0 2px"
                type="checkbox"
                class="symbol-filter-item checkbox"
                name="4"
              />
            </span>
          </td>
        </tr>
        <tr>
          <td colspan="4" class="contain-filter">
            <div style="margin-left: 10px; display: flex; align-items: center">
              <input
                style="margin: 0 5px"
                class="checkbox"
                type="checkbox"
                containfilter="1"
              />&nbsp; 除
              <input
                style="margin: 0 5px"
                class="checkbox"
                type="checkbox"
                containfilter="0"
              />
              取
            </div>
          </td>
          <td class="bc" colspan="3">
            {{
              choiceType === "D2W" ? "二" : choiceType === "D3W" ? "三" : "四"
            }}字定含
          </td>
          <td colspan="5">
            <input
              class="input left"
              style="width: 110px; height: 22px"
              name="han"
              type="text"
              maxlength="10"
            />
          </td>
          <td class="bc" colspan="4">
            {{
              choiceType === "D2W" ? "二" : choiceType === "D3W" ? "三" : "四"
            }}字定复试
          </td>
          <td colspan="4">
            <input
              class="input left"
              style="width: 110px; height: 22px"
              type="text"
              name="fushi"
              maxlength="10"
            />
          </td>
        </tr>
        <tr>
          <td colspan="20" style="text-align: left; padding-left: 15px">
            <div style="display: flex; align-items: center">
              <span
                style="
                  margin-left: 5px;
                  margin-right: 5px;
                  display: flex;
                  align-items: center;
                "
              >
                <input
                  style="margin: 0 5px"
                  type="checkbox"
                  class="repeat-two-words-filter checkbox"
                  repeatwordsfilter="1"
                />&nbsp; 除
                <input
                  style="margin: 0 5px"
                  type="checkbox"
                  class="repeat-two-words-filter checkbox"
                  repeatwordsfilter="0"
                />&nbsp; 取
                <span class="active-text">（双重）</span>
              </span>
              <span
                style="
                  display: flex;
                  align-items: center;
                  margin-left: 10px;
                  margin-right: 5px;
                "
                v-if="choiceType === 'D4W'"
              >
                <input
                  style="margin: 0 5px"
                  type="checkbox"
                  class="repeat-double-words-filter checkbox"
                  repeatwordsfilter="1"
                />&nbsp; 除
                <input
                  style="margin: 0 5px"
                  type="checkbox"
                  class="repeat-double-words-filter checkbox"
                  repeatwordsfilter="0"
                />&nbsp; 取
                <span class="active-text">（双双重）</span>
              </span>
              <span
                style="
                  display: flex;
                  align-items: center;
                  margin-left: 10px;
                  margin-right: 5px;
                "
                v-if="choiceType === 'D3W' || choiceType === 'D4W'"
              >
                <input
                  style="margin: 0 5px"
                  type="checkbox"
                  class="repeat-three-words-filter checkbox"
                  repeatwordsfilter="1"
                />&nbsp; 除
                <input
                  style="margin: 0 5px"
                  type="checkbox"
                  class="repeat-three-words-filter checkbox"
                  repeatwordsfilter="0"
                />&nbsp; 取
                <span class="active-text">（三重）</span>
              </span>
              <span
                style="display: flex; align-items: center; margin-right: 5px"
                v-if="choiceType === 'D4W'"
              >
                <input
                  style="margin: 0 5px"
                  type="checkbox"
                  class="repeat-four-words-filter checkbox"
                  repeatwordsfilter="1"
                />&nbsp; 除
                <input
                  style="margin: 0 5px"
                  type="checkbox"
                  class="repeat-four-words-filter checkbox"
                  repeatwordsfilter="0"
                />&nbsp; 取
                <span class="active-text">（四重）</span>
              </span>
            </div>
          </td>
        </tr>
        <tr>
          <td colspan="20" style="text-align: left; padding-left: 10px">
            <div style="display: flex; align-items: center">
              <span
                style="display: flex; align-items: center; margin-left: 10px"
              >
                <input
                  style="margin: 0 5px"
                  type="checkbox"
                  class="two-brother-filter checkbox"
                  brotherfilter="1"
                />&nbsp; 除
                <input
                  style="margin: 0 5px"
                  type="checkbox"
                  class="two-brother-filter checkbox"
                  brotherfilter="0"
                />&nbsp; 取
                <span class="active-text">（二兄弟）</span>
              </span>
              <span
                style="display: flex; align-items: center"
                v-if="choiceType === 'D3W' || choiceType === 'D4W'"
              >
                <input
                  style="margin: 0 5px"
                  type="checkbox"
                  class="three-brother-filter checkbox"
                  brotherfilter="1"
                />&nbsp; 除
                <input
                  style="margin: 0 5px"
                  type="checkbox"
                  class="three-brother-filter checkbox"
                  brotherfilter="0"
                />&nbsp; 取
                <span class="active-text">（三兄弟）</span>
              </span>
              <span
                style="display: flex; align-items: center"
                v-if="choiceType === 'D4W'"
              >
                <input
                  style="margin: 0 5px"
                  type="checkbox"
                  class="four-brother-filter checkbox"
                  brotherfilter="1"
                />&nbsp; 除
                <input
                  style="margin: 0 5px"
                  type="checkbox"
                  class="four-brother-filter checkbox"
                  brotherfilter="0"
                />&nbsp; 取
                <span class="active-text">（四兄弟）</span>
              </span>
            </div>
          </td>
        </tr>
        <tr>
          <td colspan="20" style="text-align: left; padding-left: 20px">
            <div style="display: flex; align-items: center">
              <input
                style="margin: 0 5px"
                type="checkbox"
                class="logarithm-number-filter checkbox"
                logarithmnumberfilter="1"
              />&nbsp; 除
              <input
                style="margin: 0 5px"
                type="checkbox"
                class="logarithm-number-filter checkbox"
                logarithmnumberfilter="0"
              />&nbsp; 取 <span class="active-text">（对数）</span>&nbsp;
              <input
                class="input left"
                style="margin: 0 5px; width: 110px; height: 22px"
                type="text"
                name="duishu1"
                maxlength="2"
              />&nbsp;
              <input
                class="input left"
                style="margin: 0 5px; width: 110px; height: 22px"
                type="text"
                name="duishu2"
                maxlength="2"
              />&nbsp;
              <input
                class="input left"
                style="margin: 0 5px; width: 110px; height: 22px"
                type="text"
                name="duishu3"
                maxlength="2"
              />&nbsp;
            </div>
          </td>
        </tr>
        <tr>
          <td colspan="20">
            <div style="display: flex; align-items: center">
              <div
                style="
                  padding-left: 15px;
                  display: flex;
                  align-items: center;
                  width: 50%;
                  text-align: left;
                "
              >
                <input
                  style="margin: 0 5px"
                  type="checkbox"
                  class="odd-number-filter checkbox"
                  oddnumberfilter="1"
                />&nbsp; 除
                <input
                  style="margin: 0 5px"
                  type="checkbox"
                  class="odd-number-filter checkbox"
                  oddnumberfilter="0"
                />&nbsp; 取
                <span class="active-text">（单）</span>
                <input type="checkbox" class="odd-number-item checkbox" />&nbsp;
                <input type="checkbox" class="odd-number-item checkbox" />&nbsp;
                <input type="checkbox" class="odd-number-item checkbox" />&nbsp;
                <input type="checkbox" class="odd-number-item checkbox" />&nbsp;
                <input type="checkbox" class="odd-number-item checkbox" />&nbsp;
              </div>
              <div
                style="
                  display: flex;
                  align-items: center;
                  width: 50%;
                  text-align: left;
                "
              >
                <input
                  type="checkbox"
                  class="even-number-filter checkbox"
                  evennumberfilter="1"
                />&nbsp; 除
                <input
                  style="margin: 0 5px"
                  type="checkbox"
                  class="even-number-filter checkbox"
                  evennumberfilter="0"
                />&nbsp; 取
                <span class="active-text">（双）</span>
                <input
                  type="checkbox"
                  class="even-number-item checkbox"
                />&nbsp;
                <input
                  type="checkbox"
                  class="even-number-item checkbox"
                />&nbsp;
                <input
                  type="checkbox"
                  class="even-number-item checkbox"
                />&nbsp;
                <input
                  type="checkbox"
                  class="even-number-item checkbox"
                />&nbsp;
                <input
                  type="checkbox"
                  class="even-number-item checkbox"
                />&nbsp;
              </div>
            </div>
          </td>
        </tr>
        <tr>
          <td class="bc btn-group" colspan="20">
            <input
              class="create btn primary"
              type="button"
              value="生成"
              @click="create()"
            />
            <input
              class="btn info"
              type="button"
              value="重置"
              @click="reset()"
            />
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      choiceType: "D2W",
      showPeiSu: false,
      totalMoney: "",
      totalNum: "",
      money: "",
      htmlData: "",
      createNumberArr: [],
    };
  },
  watch: {
    initFinished() {
      this.initData();
    },
    money() {
      this.totalMoney = this.money * this.totalNum || "";
    },
    choiceType() {
      this.$nextTick(function () {
        this.bindFunction();
        this.reset();
      });
    },
  },
  props: ["initFinished", "isClose"],
  mounted() {
    this.initData();
  },
  methods: {
    initData() {
      if (this.initFinished) {
        this.bindFunction();
      }
    },
    async submit() {
      if (this.isClose == 0) {
        if (this.createNumberArr.length > 0) {
          // getDWTypeByName
          this.createNumberArr.forEach((item, index) => {
            if (item.length === 5 && item.substr(4, 1) === "X") {
              this.createNumberArr[index] = item.substr(0, 4);
            }
          });
          let data = {
            access_token: this.$store.state.userInfo.access_token,
            uid: this.$store.state.userInfo.uid,
            game_code: this.$store.state.gameInfo[0].code,
            play_code: this.choiceType,
            key: new Date().valueOf(),
            play_type: "kuaixuan",
            bet_money: this.money,
            total_money: this.totalMoney,
            bet_num: this.totalNum,
            bet_str: this.createNumberArr.join(","),
            bet_log: "游戏日志",
            bet_qihao: this.$store.state.gameInfo[0].nextQihao,
          };
          let result = await this.$http.postAxiosMethod("/user/bet", data);
          if (result.code == 0) {
            this.$message({
              iconClass: "fa fa-check-circle",
              customClass: "bet_message",
              type: "success",
              duration: 3000,
              message: "下注成功！",
            });
            this.reset();
            setTimeout(() => {
              this.$BUS.$emit("bet");
            }, 500);
          }
        }
      } else {
        document.activeElement.blur();
        this.$alert("已封盘", "提示");
      }
    },
    reset() {
      $("#kx_content input[type='text']").val("");
      $("#kx_content input[type='checkbox']:not(.initChecked)").attr(
        "checked",
        false
      );
      this.htmlData = "";
      this.money = "";
      this.money = "";
      this.totalNum = "";
      this.totalMoney = "";
    },
    bindFunction() {
      let _this = this;
      $("#kx_content input[type='text']").keyup(function () {
        $(this).val(
          $(this)
            .val()
            .replace(/[^0-9]/g, "")
        );
      });

      $("#kx_content .position-filter input")
        .unbind("change")
        .change(function () {
          var positiontype = $(this).attr("positiontype");
          if (positiontype == 1) {
            _this.showPeiSu = true;
          } else {
            _this.showPeiSu = false;
          }
          var positionfilter = $(this).attr("positionfilter");
          for (
            let i = 0;
            i < $("#kx_content .position-filter input").length;
            i++
          ) {
            document.getElementById("kx_content").getElementsByTagName("input")[
              i
            ].checked = false;
          }
          $(this)[0].checked = true;

          // if (positiontype == 0) {
          //     $("#kx_content .fixed-input").attr("style", "");
          //     $("#kx_content .match-input").attr("style", "display: none");
          //     $("#kx_content .match-input input[type='text']").val('');
          // } else {
          //     $("#kx_content .fixed-input").attr("style", "display: none");
          //     $("#kx_content .match-input").attr("style", "");
          //     $("#kx_content .fixed-input input[type='text']").val('');
          // }
        });

      $("#kx_content .hefen-filter input")
        .unbind("change")
        .change(function () {
          let checkBox = $("#kx_content .hefen-filter input");
          for (let i = 0; i < checkBox.length; i++) {
            checkBox[i].checked = false;
          }
          $(this)[0].checked = true;
        });

      $("#kx_content .budinghe-filter input[type='checkbox']")
        .unbind("change")
        .change(function () {
          if ($(this).attr("checked") == "checked") {
            $("#kx_content .budinghe-filter input[type='checkbox']").attr(
              "checked",
              false
            );
            $(this).attr("checked", "checked");
          }
        });

      $("#kx_content .contain-filter input[type='checkbox']")
        .unbind("change")
        .change(function () {
          let checkBox = $(
            "#kx_content .contain-filter input[type='checkbox']"
          );
          for (let i = 0; i < checkBox.length; i++) {
            if (checkBox[i] != this) {
              checkBox[i].checked = false;
            }
          }
        });

      $("#kx_content  .repeat-two-words-filter")
        .unbind("change")
        .change(function () {
          let checkBox = $("#kx_content .repeat-two-words-filter");
          for (let i = 0; i < checkBox.length; i++) {
            if (checkBox[i] != this) {
              checkBox[i].checked = false;
            }
          }
        });

      $("#kx_content .repeat-three-words-filter")
        .unbind("change")
        .change(function () {
          let checkBox = $("#kx_content .repeat-three-words-filter");
          for (let i = 0; i < checkBox.length; i++) {
            if (checkBox[i] != this) {
              checkBox[i].checked = false;
            }
          }
        });

      $("#kx_content .repeat-four-words-filter")
        .unbind("change")
        .change(function () {
          let checkBox = $("#kx_content .repeat-four-words-filter");
          for (let i = 0; i < checkBox.length; i++) {
            if (checkBox[i] != this) {
              checkBox[i].checked = false;
            }
          }
        });

      $("#kx_content .repeat-double-words-filter")
        .unbind("change")
        .change(function () {
          let checkBox = $("#kx_content .repeat-double-words-filter");
          for (let i = 0; i < checkBox.length; i++) {
            if (checkBox[i] != this) {
              checkBox[i].checked = false;
            }
          }
        });

      $("#kx_content .two-brother-filter")
        .unbind("change")
        .change(function () {
          let checkBox = $("#kx_content .two-brother-filter");
          for (let i = 0; i < checkBox.length; i++) {
            if (checkBox[i] != this) {
              checkBox[i].checked = false;
            }
          }
        });

      $("#kx_content .three-brother-filter")
        .unbind("change")
        .change(function () {
          let checkBox = $("#kx_content .three-brother-filter");
          for (let i = 0; i < checkBox.length; i++) {
            if (checkBox[i] != this) {
              checkBox[i].checked = false;
            }
          }
        });

      $("#kx_content .four-brother-filter")
        .unbind("change")
        .change(function () {
          let checkBox = $("#kx_content .four-brother-filter");
          for (let i = 0; i < checkBox.length; i++) {
            if (checkBox[i] != this) {
              checkBox[i].checked = false;
            }
          }
        });

      $("#kx_content .logarithm-number-filter")
        .unbind("change")
        .change(function () {
          let checkBox = $("#kx_content .logarithm-number-filter");
          for (let i = 0; i < checkBox.length; i++) {
            if (checkBox[i] != this) {
              checkBox[i].checked = false;
            }
          }
        });

      $("#kx_content .odd-number-filter")
        .unbind("change")
        .change(function () {
          let checkBox = $("#kx_content .odd-number-filter");
          for (let i = 0; i < checkBox.length; i++) {
            if (checkBox[i] != this) {
              checkBox[i].checked = false;
            }
          }
        });

      $("#kx_content .even-number-filter")
        .unbind("change")
        .change(function () {
          let checkBox = $("#kx_content .even-number-filter");
          for (let i = 0; i < checkBox.length; i++) {
            if (checkBox[i] != this) {
              checkBox[i].checked = false;
            }
          }
        });

      let inputNodeChecked = false;
      $("#wwrdPnode").on("click", $("#wwrd"), () => {
        inputNodeChecked = !inputNodeChecked;
        $("#wwrd")[0].checked = inputNodeChecked;
      });

      let zdz = document.getElementsByClassName("zdz");
      for (let i = 0; i < zdz.length; i++) {
        zdz[i].onclick = function () {
          for (let q = 0; q < zdz.length; q++) {
            zdz[q].checked = false;
          }
          zdz[i].checked = true;
        };
      }
    },
    create() {
      var positiontype = $("#kx_content .position-filter input:checked").attr(
        "positiontype"
      );
      var positionfilter = $("#kx_content .position-filter input:checked").attr(
        "positionfilter"
      );
      var category =
        this.choiceType === "D2W" ? 2 : this.choiceType === "D3W" ? 3 : 4;

      //五位
      var dw5zi = 0;
      if (category == 4) {
        var obj = $("#kx_content input[name='dw5zi']:checked");
        if (obj) dw5zi = obj.attr("data-index");
      } else
        dw5zi =
          $("#kx_content input[name='dw5zi']").attr("checked") == "checked"
            ? 1
            : 0;

      //日志
      var kxlog = [];
      //生成号码数字
      var createNumberArr = [];
      //是否有输入条件
      var inputCondition = false;
      //全部号码
      var allNumberArr = [];
      //定位置
      if (positiontype == 0) {
        var wan = $("#kx_content input[name='wan']").val();
        var qian = $("#kx_content input[name='qian']").val();
        var bai = $("#kx_content input[name='bai']").val();
        var shi = $("#kx_content input[name='shi']").val();
        var ge = $("#kx_content input[name='ge']").val();

        var posNumArr = [wan, qian, bai, shi, ge];
        //填写号码的位置
        var numPos = [];
        wan.length > 0 ? numPos.push(0) : "";
        qian.length > 0 ? numPos.push(1) : "";
        bai.length > 0 ? numPos.push(2) : "";
        shi.length > 0 ? numPos.push(3) : "";
        ge.length > 0 ? numPos.push(4) : "";

        if (numPos.length > 0) {
          inputCondition = true;
          kxlog.push("1|" + positionfilter + "|" + posNumArr.join(":"));
        }

        if (category == numPos.length) {
          createNumberArr = this.dwcreatenumber(category, posNumArr, numPos);

          //除
          if (positionfilter == 1) {
            var tmpPosNumArr = ["", "", "", "", ""];
            for (var n = 0; n < numPos.length; n++) {
              tmpPosNumArr[numPos[n]] = "0123456789";
            }
            allNumberArr = this.dwcreatenumber(category, tmpPosNumArr, numPos);
          }
        } else if (numPos.length > 0 && numPos.length < category) {
          var numPosArr;
          if (category == 2) {
            if (dw5zi == 0)
              numPosArr = [
                [0, 1],
                [0, 2],
                [0, 3],
                [1, 2],
                [1, 3],
                [2, 3],
              ];
            else
              numPosArr = [
                [0, 4],
                [1, 4],
                [2, 4],
                [3, 4],
              ];
          } else if (category == 3) {
            if (dw5zi == 0)
              numPosArr = [
                [0, 1, 2],
                [0, 1, 3],
                [0, 2, 3],
                [1, 2, 3],
              ];
            else
              numPosArr = [
                [0, 1, 4],
                [0, 2, 4],
                [0, 3, 4],
                [1, 2, 4],
                [1, 3, 4],
                [2, 3, 4],
              ];
          } else if (category == 4) {
            numPosArr = [
              [0, 1, 2, 3],
              [0, 1, 2, 4],
              [0, 1, 3, 4],
              [0, 2, 3, 4],
              [1, 2, 3, 4],
            ];
            var index = [4, 3, 2, 1, 0];
            numPosArr = [numPosArr[index[dw5zi - 1]]];
          }

          for (var i = 0; i < numPosArr.length; i++) {
            tmpPosNumArr = posNumArr;
            var posArr = numPosArr[i];

            var c = false;
            for (var n = 0; n < numPos.length; n++) {
              if (posArr.indexOf(numPos[n]) == -1) {
                c = true;
                break;
              }
            }
            if (c) continue;

            var tmpPosNumArr2 = ["", "", "", "", ""];
            for (var n = 0; n < posArr.length; n++) {
              if (tmpPosNumArr[posArr[n]].length == 0)
                tmpPosNumArr[posArr[n]] = "0123456789";

              if (positionfilter == 1) {
                tmpPosNumArr2[posArr[n]] = "0123456789";
              }
            }

            createNumberArr = createNumberArr.concat(
              this.dwcreatenumber(category, tmpPosNumArr, posArr)
            );
            if (positionfilter == 1)
              allNumberArr = allNumberArr.concat(
                this.dwcreatenumber(category, tmpPosNumArr2, posArr)
              );
          }
        }
      } else {
        //配数
        var peiNumArr = [];
        var peiNumArr2 = [];
        for (var i = 1; i <= category; i++) {
          var psn = $(
            "#kx_content tr.match-input input[name='pei" + i + "']"
          ).val();
          if (psn.length > 0) {
            inputCondition = true;
            peiNumArr2.push(psn);
          }
          peiNumArr.push(psn.length == 0 ? "0123456789" : psn);
        }

        if (inputCondition) {
          if (positionfilter == 1)
            allNumberArr = this.getNumbersByCategory(category, dw5zi);
          createNumberArr = this.peishuquanzhuan(
            category,
            peiNumArr,
            dw5zi,
            false
          );

          kxlog.push("2|" + positionfilter + "|" + peiNumArr2.join(":"));
        }
      }

      if (positionfilter == 1) {
        var newNumberArr = [];
        for (var n = 0; n < allNumberArr.length; n++) {
          if (createNumberArr.indexOf(allNumberArr[n]) == -1)
            newNumberArr.push(allNumberArr[n]);
        }
        createNumberArr = newNumberArr;
      }

      //全转
      var quanzhaun = $("#kx_content input[name='quanzhuan']").val();
      if (quanzhaun.length > 0) {
        tmpNumArr = [];
        if (quanzhaun.length >= category) {
          var quanzhaunArr = [];
          for (var i = 0; i < category; i++) {
            quanzhaunArr.push(quanzhaun);
          }
          tmpNumArr = this.peishuquanzhuan(category, quanzhaunArr, dw5zi, true);
        }
        if (createNumberArr.length == 0 && inputCondition) {
          createNumberArr = [];
        } else if (createNumberArr.length == 0) createNumberArr = tmpNumArr;
        else {
          var tmpNumArr2 = [];
          for (var i = 0; i < tmpNumArr.length; i++) {
            if (createNumberArr.indexOf(tmpNumArr[i]) != -1) {
              tmpNumArr2.push(tmpNumArr[i]);
            }
          }
          createNumberArr = tmpNumArr2;
        }
        inputCondition = true;
        kxlog.push("3|" + quanzhaun);
      }

      //上将
      var shangjiang = $("#kx_content input[name='shangjiang']").val();
      if (shangjiang.length > 0) {
        allNumberArr = this.getNumbersByCategory(category, dw5zi);
        var tmpNumArr = [];
        for (var n = 0; n < allNumberArr.length; n++) {
          var number = allNumberArr[n];
          var pos = [];
          for (var n2 = 0; n2 < number.length; n2++) {
            for (var n3 = 0; n3 < shangjiang.length; n3++) {
              if (number[n2] == shangjiang[n3] && pos.indexOf(n3) == -1) {
                pos.push(n3);
                break;
              }
            }
          }
          pos = pos.uniquelize();

          if (pos.length == shangjiang.length || pos.length == category)
            tmpNumArr.push(number);
        }

        if (!inputCondition && quanzhaun.length == 0) {
          createNumberArr = tmpNumArr;
        } else if (createNumberArr.length > 0) {
          if (tmpNumArr.length == 0) createNumberArr = [];
          else createNumberArr = Array.intersect(createNumberArr, tmpNumArr);
        }

        inputCondition = true;
        kxlog.push("4|" + shangjiang);
      }

      //值范围
      if (category == 4) {
        var zhifanwei1 = $("#kx_content input[name='zhifanwei1']").val();
        var zhifanwei2 = $("#kx_content input[name='zhifanwei2']").val();
        if (zhifanwei1.length > 0 && zhifanwei2.length > 0) {
          tmpNumArr = [];

          if (
            !inputCondition &&
            quanzhaun.length == 0 &&
            shangjiang.length == 0
          ) {
            allNumberArr = this.getNumbersByCategory(category, dw5zi);
            for (var i = 0; i < allNumberArr.length; i++) {
              var number = allNumberArr[i];
              number = number.replace(/X/g, "");
              var he =
                parseInt(number[0]) +
                parseInt(number[1]) +
                parseInt(number[2]) +
                parseInt(number[3]);
              if (he >= parseInt(zhifanwei1) && he <= parseInt(zhifanwei2))
                tmpNumArr.push(allNumberArr[i]);
            }
            createNumberArr = tmpNumArr;
          } else if (createNumberArr.length > 0) {
            for (var i = 0; i < createNumberArr.length; i++) {
              var number = createNumberArr[i];
              number = number.replace(/X/g, "");
              var he =
                parseInt(number[0]) +
                parseInt(number[1]) +
                parseInt(number[2]) +
                parseInt(number[3]);
              if (he >= parseInt(zhifanwei1) && he <= parseInt(zhifanwei2))
                tmpNumArr.push(createNumberArr[i]);
            }
            createNumberArr = tmpNumArr;
          }

          inputCondition = true;
          kxlog.push("5|" + zhifanwei1 + "~" + zhifanwei2);
        }
      }

      //合分
      var hefentype = $("#kx_content tr.hefen-filter input:checked").attr(
        "hefentype"
      );

      var hefenInfo = [];
      $("#kx_content td.hefen-filter-item").each(function () {
        var hf = $(this).find("input[type='text']").val();
        if (hf == "") return true;
        var i = 0;
        var pos = [];
        $(this)
          .find("input[type='checkbox']")
          .each(function () {
            if ($(this).prop("checked")) {
              pos.push(i);
            }
            i++;
          });

        if (pos.length > 0) {
          hefenInfo.push(pos.join(":") + "-" + hf);
        }
      });
      var tmpNumArr = [];
      if (hefenInfo.length > 0) {
        if (!inputCondition)
          createNumberArr = this.getNumbersByCategory(category, dw5zi);
        for (var i = 0; i < createNumberArr.length; i++) {
          var count = 0;
          for (var n = 0; n < hefenInfo.length; n++) {
            var hf = hefenInfo[n].split("-")[1];
            var hfpos = hefenInfo[n].split("-")[0].split(":");
            var hf2 = 0;
            for (var n2 = 0; n2 < hfpos.length; n2++) {
              if (createNumberArr[i][hfpos[n2]] == "X") {
                hf2 = -1;
                break;
              }
              hf2 += parseInt(createNumberArr[i][hfpos[n2]]);
            }
            if (hf2 < 0) continue;

            for (var n3 = 0; n3 < hf.length; n3++) {
              if (hf2 % 10 == hf[n3]) {
                count++;
                break;
              }
            }
          }
          if (
            (count == hefenInfo.length && hefentype == 0) ||
            (count != hefenInfo.length && hefentype == 1)
          )
            tmpNumArr.push(createNumberArr[i]);
        }
        createNumberArr = tmpNumArr;
        inputCondition = true;
        kxlog.push("6|" + hefentype + "|" + hefenInfo.join(";"));
      }

      //不定位合分
      var budinghetype = $(
        "#kx_content td.budinghe-filter input[type=checkbox]:checked"
      ).attr("budinghetype");
      var budinghe = $(
        "#kx_content td.budinghe-filter+td input[type='text']"
      ).val();

      if ((budinghetype == 2 || budinghetype == 3) && budinghe.length > 0) {
        if (!inputCondition)
          createNumberArr = this.getNumbersByCategory(category, dw5zi);

        tmpNumArr = [];
        for (var i = 0; i < createNumberArr.length; i++) {
          var number = createNumberArr[i];
          number = number.replace("/X/g", "");
          var ext = false;
          for (var n = 0; n < number.length; n++) {
            for (var n2 = n + 1; n2 < number.length; n2++) {
              if (budinghetype == 2) {
                var value = (parseInt(number[n]) + parseInt(number[n2])) % 10;
                if (budinghe.indexOf(value) != -1) {
                  tmpNumArr.push(createNumberArr[i]);
                  ext = true;
                  break;
                }
              } else {
                for (var n3 = n2 + 1; n3 < number.length; n3++) {
                  var value =
                    (parseInt(number[n]) +
                      parseInt(number[n2]) +
                      parseInt(number[n3])) %
                    10;
                  if (budinghe.indexOf(value) != -1) {
                    tmpNumArr.push(createNumberArr[i]);
                    ext = true;
                    break;
                  }
                }
              }
              if (ext) break;
            }
            if (ext) break;
          }
        }

        createNumberArr = tmpNumArr;
        inputCondition = true;
        kxlog.push("7|" + budinghetype + "|" + budinghe);
      }

      //排除
      var paichu = $("#kx_content input[name='paichu']").val();
      if (paichu.length > 0) {
        if (!inputCondition)
          createNumberArr = this.getNumbersByCategory(category, dw5zi);
        tmpNumArr = [];
        for (var i = 0; i < createNumberArr.length; i++) {
          var number = createNumberArr[i];

          var b = false;
          for (var n = 0; n < paichu.length; n++) {
            if (number.indexOf(paichu[n]) != -1) {
              b = true;
              break;
            }
          }
          if (!b) tmpNumArr.push(number);
        }
        createNumberArr = tmpNumArr;
        inputCondition = true;
        kxlog.push("8|" + paichu);
      }

      //乘号位置
      var chhaoArr = [];
      $("#kx_content input.symbol-filter-item:checked").each(function () {
        chhaoArr.push($(this).attr("name"));
      });
      if (chhaoArr.length > 0 && category != 4) {
        if (!inputCondition)
          createNumberArr = this.getNumbersByCategory(category, dw5zi);
        tmpNumArr = [];
        for (var i = 0; i < createNumberArr.length; i++) {
          var number = createNumberArr[i];
          b = true;
          for (var n = 0; n < chhaoArr.length; n++) {
            if (number[chhaoArr[n]] != "X") {
              b = false;
              break;
            }
          }
          if (b) tmpNumArr.push(number);
        }
        createNumberArr = tmpNumArr;
        inputCondition = true;
        kxlog.push("9|" + chhaoArr.join(":"));
      }
      //含数复数
      var containfilter = $(
        "#kx_content td.contain-filter input[type='checkbox']:checked"
      ).attr("containfilter");
      var han = $("#kx_content input[name='han']").val();
      var fushi = $("#kx_content input[name='fushi']").val();
      if (containfilter >= 0 && han.length > 0) {
        if (!inputCondition)
          createNumberArr = this.getNumbersByCategory(category, dw5zi);
        tmpNumArr = [];
        for (var i = 0; i < createNumberArr.length; i++) {
          var number = createNumberArr[i];
          b = false;
          for (var n = 0; n < han.length; n++) {
            if (number.indexOf(han[n]) != -1) {
              b = true;
              break;
            }
          }
          if (containfilter == 0 && b) tmpNumArr.push(number);
          else if (containfilter == 1 && !b) tmpNumArr.push(number);
        }
        createNumberArr = tmpNumArr;
        inputCondition = true;
        kxlog.push("10|" + containfilter + "|" + han);
      }

      if (containfilter >= 0 && fushi.length > 0) {
        if (!inputCondition)
          createNumberArr = this.getNumbersByCategory(category, dw5zi);
        tmpNumArr = [];
        for (var i = 0; i < createNumberArr.length; i++) {
          var number = createNumberArr[i];
          b = true;
          for (var n = 0; n < number.length; n++) {
            if (number[n] != "X" && fushi.indexOf(number[n]) == -1) {
              b = false;
              break;
            }
          }
          if (containfilter == 0 && b) tmpNumArr.push(number);
          else if (containfilter == 1 && !b) tmpNumArr.push(number);
        }
        createNumberArr = tmpNumArr;
        inputCondition = true;
        kxlog.push("11|" + containfilter + "|" + fushi);
      }

      //重
      var chongname = ["two", "three", "four", "double"];
      var len = category < 4 ? category - 1 : category;
      var chongArr = [];
      for (var n = 0; n < len; n++) {
        var repeatwordsfilter = $(
          "#kx_content  input[class='repeat-" +
            chongname[n] +
            "-words-filter checkbox']:checked"
        ).attr("repeatwordsfilter");
        console.log("repeatwordsfilter", repeatwordsfilter);
        if (repeatwordsfilter >= 0) {
          chongArr.push(n + ":" + repeatwordsfilter);
        }
      }
      if (chongArr.length > 0) {
        if (!inputCondition)
          createNumberArr = this.getNumbersByCategory(category, dw5zi);
        inputCondition = true;
        tmpNumArr = [];
        for (var i = 0; i < createNumberArr.length; i++) {
          var number = createNumberArr[i];
          var b = true;

          for (var n = 0; n < chongArr.length; n++) {
            var chcondition = chongArr[n];

            var index = parseInt(chcondition.split(":")[0]);
            var qu = parseInt(chcondition.split(":")[1]);
            var count = this.chong(number);

            //双重
            if (index == 0 && qu == 0 && count < 2) b = false;
            if (index == 0 && qu == 1 && count >= 2) b = false;
            if (index == 0 && qu >= 0 && !b) break;

            //三重
            if (category >= 3) {
              if (index == 1 && qu == 0 && !(count >= 3 && count <= 4))
                b = false;
              if (index == 1 && qu == 1 && count >= 3 && count <= 4) b = false;
              if (index == 1 && qu >= 0 && !b) break;
            }

            if (category == 4) {
              //双双重
              if (index == 3 && qu == 0 && !(count >= 4 && count <= 5))
                b = false;
              if (index == 3 && qu == 1 && count >= 4 && count <= 5) b = false;
              if (index == 3 && qu >= 0 && !b) break;

              //四重
              if (index == 2 && qu == 0 && !(count == 4)) b = false;
              if (index == 2 && qu == 1 && count == 4) b = false;
              if (index == 2 && qu >= 0 && !b) break;
            }
          }

          if (b) tmpNumArr.push(number);
        }
        createNumberArr = tmpNumArr;
        kxlog.push("12|" + chongArr.join("|"));
      }

      //对数
      var logarithmnumberfilter = $(
        "#kx_content input[class='logarithm-number-filter checkbox']:checked"
      ).attr("logarithmnumberfilter");
      var duishuiArr = [];
      for (var n = 1; n <= 3; n++) {
        var ds = $("#kx_content input[name='duishu" + n + "'] ").val();
        if (ds.length == 2 && (ds[0] - ds[1] == 5 || ds[0] - ds[1] == -5)) {
          duishuiArr.push(ds);
        } else if (ds.length > 0) {
          document.activeElement.blur();
          this.$alert("请输入差值为5的数", "提示");
          return;
        }
      }
      if (logarithmnumberfilter >= 0 && duishuiArr.length > 0) {
        if (!inputCondition)
          createNumberArr = this.getNumbersByCategory(category, dw5zi);
        inputCondition = true;
        tmpNumArr = [];
        for (var i = 0; i < createNumberArr.length; i++) {
          number = createNumberArr[i];
          b = false;
          for (var n = 0; n < duishuiArr.length; n++) {
            if (
              number.indexOf(duishuiArr[n][0]) != -1 &&
              number.indexOf(duishuiArr[n][1]) != -1
            ) {
              b = true;
              break;
            }
          }

          if (logarithmnumberfilter == 1) b = !b;

          if (b) tmpNumArr.push(number);
        }
        createNumberArr = tmpNumArr;
        kxlog.push("13|" + logarithmnumberfilter + "|" + duishuiArr.join(":"));
      } else if (logarithmnumberfilter >= 0 && duishuiArr.length == 0) {
        if (!inputCondition)
          createNumberArr = this.getNumbersByCategory(category, dw5zi);
        inputCondition = true;
        tmpNumArr = [];
        for (var i = 0; i < createNumberArr.length; i++) {
          number = createNumberArr[i];
          number = number.replace(/X/g, "");
          b = false;
          for (var n = 0; n < number.length - 1; n++) {
            for (var n2 = n + 1; n2 < number.length; n2++)
              if (number[n] - number[n2] == 5 || number[n] - number[n2] == -5) {
                b = true;
                break;
              }
          }

          if (logarithmnumberfilter == 1) b = !b;

          if (b) tmpNumArr.push(createNumberArr[i]);
        }
        createNumberArr = tmpNumArr;
        kxlog.push("13|" + logarithmnumberfilter + "| ");
      }

      var brotherClass = ["two", "three", "four"];
      var brotherArr = [];
      for (var n = 0; n < category - 1; n++) {
        var brotherfilter = $(
          "#kx_content input[class='" +
            brotherClass[n] +
            "-brother-filter checkbox']:checked"
        ).attr("brotherfilter");
        if (brotherfilter >= 0) {
          brotherArr.push(n + ":" + brotherfilter);
        }
      }
      if (brotherArr.length > 0) {
        if (!inputCondition)
          createNumberArr = this.getNumbersByCategory(category, dw5zi);
        inputCondition = true;

        tmpNumArr = [];
        for (var i = 0; i < createNumberArr.length; i++) {
          var number = createNumberArr[i];
          var b = true;
          for (var k = 0; k < brotherArr.length; k++) {
            var index = brotherArr[k].split(":")[0];
            var qu = brotherArr[k].split(":")[1];

            if (index == 0 && qu == 0 && this.brother(number) < 2) b = false;
            if (index == 0 && qu == 1 && this.brother(number) >= 2) b = false;

            if (index == 1 && qu == 0 && this.brother(number) < 3) b = false;
            if (index == 1 && qu == 1 && this.brother(number) >= 3) b = false;

            if (index == 2 && qu == 0 && this.brother(number) != 4) b = false;
            if (index == 2 && qu == 1 && this.brother(number) == 4) b = false;

            if (!b) break;
          }
          if (b) tmpNumArr.push(number);
        }
        createNumberArr = tmpNumArr;
        kxlog.push("14|" + brotherArr.join("|"));
      }

      var oddnumberfilter = $(
        "#kx_content input[class='odd-number-filter checkbox']:checked"
      ).attr("oddnumberfilter");
      var evennumberfilter = $(
        "#kx_content input[class='even-number-filter checkbox']:checked"
      ).attr("evennumberfilter");
      var oddnumberArr = [];
      var evennumberArr = [];

      var depos = 0;
      $("#kx_content input[class='odd-number-item']").each(function () {
        if ($(this).attr("checked")) oddnumberArr.push(depos);
        depos++;
      });

      if (oddnumberfilter >= 0 && oddnumberArr.length > 0) {
        if (!inputCondition)
          createNumberArr = this.getNumbersByCategory(category, dw5zi);
        inputCondition = true;
        tmpNumArr = [];
        for (var i = 0; i < createNumberArr.length; i++) {
          var number = createNumberArr[i];
          var b = true;
          for (var n = 0; n < oddnumberArr.length; n++) {
            if (
              number[oddnumberArr[n]] == "X" ||
              parseInt(number[oddnumberArr[n]]) % 2 == 0
            ) {
              b = false;
              break;
            }
          }

          if (oddnumberfilter == 1) b = !b;
          if (b) tmpNumArr.push(number);
        }
        createNumberArr = tmpNumArr;
        kxlog.push("15|" + oddnumberfilter + "|" + oddnumberArr.join("|"));
      }

      depos = 0;
      $("#kx_content input[class='even-number-item']").each(function () {
        if ($(this).attr("checked")) evennumberArr.push(depos);
        depos++;
      });

      if (evennumberfilter >= 0 && evennumberArr.length > 0) {
        if (!inputCondition)
          createNumberArr = this.getNumbersByCategory(category, dw5zi);
        inputCondition = true;
        tmpNumArr = [];
        for (var i = 0; i < createNumberArr.length; i++) {
          var number = createNumberArr[i];
          var b = true;
          for (var n = 0; n < evennumberArr.length; n++) {
            if (
              number[evennumberArr[n]] == "X" ||
              parseInt(number[evennumberArr[n]]) % 2 != 0
            ) {
              b = false;
              break;
            }
          }

          if (evennumberfilter == 1) b = !b;
          if (b) tmpNumArr.push(number);
        }
        createNumberArr = tmpNumArr;
        kxlog.push("16|" + evennumberfilter + "|" + evennumberArr.join("|"));
      }

      if (!inputCondition) {
        document.activeElement.blur();
        this.$alert("请选择或填写条件生成！", "提示");
        return;
      }

      //kxnumbers
      if (createNumberArr.length == 0) {
        htmlData = "没有这样的号码";
        this.htmlData = htmlData;
      } else {
        createNumberArr = createNumberArr.sort();
        var row = parseInt(createNumberArr.length / 10);
        if (createNumberArr.length % 10 > 0) row += 1;
        var htmlData = [];
        htmlData.push("<table cellpadding='0' cellspacing='0'>");
        htmlData.push("<tbody >");

        for (var n = 0; n < row; n++) {
          htmlData.push("<tr>");
          for (var n2 = 0; n2 < 10; n2++) {
            if (n * 10 + n2 < createNumberArr.length) {
              var num = createNumberArr[n * 10 + n2];
              htmlData.push(
                "<td >" +
                  (num[4] == "X"
                    ? num.substring(0, num.lastIndexOf("X"))
                    : num) +
                  "</td>"
              );
            } else {
              htmlData.push("<td >--</td>");
            }
          }
          htmlData.push("</tr>");
        }

        htmlData.push("</tbody>");
        htmlData.push("</table>");
        this.htmlData = htmlData.join("");
        this.totalNum = createNumberArr.length;
        this.totalMoney = createNumberArr.length * this.money || "";
        this.createNumberArr = createNumberArr;
        // $("#kxnumbers").html(htmlData.join(""));
        // $("#kxlog").html(category + "," + dw5zi + "," + kxlog.join(","));
        // $("#zbishu").html(createNumberArr.length);
        // if ($("#tool_ys_input").val().length > 0) {
        //     $("#zmoney").html(parseFloat($("#tool_ys_input").val()) * createNumberArr.length)
        // } else {
        //     $("#zmoney").html("");
        // }
      }
      this.$refs.money.focus();
    },
    dwcreatenumber(category, posNumArr, numPos) {
      var createNumberArr = [];
      if (category == 2) {
        for (var i = 0; i < posNumArr[numPos[0]].length; i++) {
          for (var n = 0; n < posNumArr[numPos[1]].length; n++) {
            var number = ["X", "X", "X", "X", "X"];
            number[numPos[0]] = posNumArr[numPos[0]][i];
            number[numPos[1]] = posNumArr[numPos[1]][n];
            if (createNumberArr.indexOf(number.join("")) == -1)
              createNumberArr.push(number.join(""));
          }
        }
      } else if (category == 3) {
        for (var i = 0; i < posNumArr[numPos[0]].length; i++) {
          for (var n = 0; n < posNumArr[numPos[1]].length; n++) {
            for (var n2 = 0; n2 < posNumArr[numPos[2]].length; n2++) {
              var number = ["X", "X", "X", "X", "X"];
              number[numPos[0]] = posNumArr[numPos[0]][i];
              number[numPos[1]] = posNumArr[numPos[1]][n];
              number[numPos[2]] = posNumArr[numPos[2]][n2];
              if (createNumberArr.indexOf(number.join("")) == -1)
                createNumberArr.push(number.join(""));
            }
          }
        }
      } else if (category == 4) {
        for (var i = 0; i < posNumArr[numPos[0]].length; i++) {
          for (var n = 0; n < posNumArr[numPos[1]].length; n++) {
            for (var n2 = 0; n2 < posNumArr[numPos[2]].length; n2++) {
              for (var n3 = 0; n3 < posNumArr[numPos[3]].length; n3++) {
                var number = ["X", "X", "X", "X", "X"];
                number[numPos[0]] = posNumArr[numPos[0]][i];
                number[numPos[1]] = posNumArr[numPos[1]][n];
                number[numPos[2]] = posNumArr[numPos[2]][n2];
                number[numPos[3]] = posNumArr[numPos[3]][n3];
                if (createNumberArr.indexOf(number.join("")) == -1)
                  createNumberArr.push(number.join(""));
              }
            }
          }
        }
      }
      return createNumberArr;
    },
    getNumbersByCategory(category, dw5zi) {
      var numPosArr;
      if (category == 2) {
        if (dw5zi == 0)
          numPosArr = [
            [0, 1],
            [0, 2],
            [0, 3],
            [1, 2],
            [1, 3],
            [2, 3],
          ];
        else
          numPosArr = [
            [0, 4],
            [1, 4],
            [2, 4],
            [3, 4],
          ];
      } else if (category == 3) {
        if (dw5zi == 0)
          numPosArr = [
            [0, 1, 2],
            [0, 1, 3],
            [0, 2, 3],
            [1, 2, 3],
          ];
        else
          numPosArr = [
            [0, 1, 4],
            [0, 2, 4],
            [0, 3, 4],
            [1, 2, 4],
            [1, 3, 4],
            [2, 3, 4],
          ];
      } else if (category == 4) {
        numPosArr = [
          [0, 1, 2, 3],
          [0, 1, 2, 4],
          [0, 1, 3, 4],
          [0, 2, 3, 4],
          [1, 2, 3, 4],
        ];
        var index = [4, 3, 2, 1, 0];
        numPosArr = [numPosArr[index[dw5zi - 1]]];
      }
      var allNumberArr = [];
      for (var i = 0; i < numPosArr.length; i++) {
        var allPeiNumArr = [];
        var posArr = numPosArr[i];
        for (var n = 0; n < posArr.length; n++) {
          allPeiNumArr[posArr[n]] = "0123456789";
        }

        allNumberArr = allNumberArr.concat(
          this.dwcreatenumber(category, allPeiNumArr, posArr)
        );
      }
      return allNumberArr;
    },
    peishuquanzhuan(category, peiNumArr, dw5zi, qz) {
      var createNumberArr = [];
      if (category == 2) {
        for (var n = 0; n < peiNumArr[0].length; n++) {
          for (var n2 = 0; n2 < peiNumArr[1].length; n2++) {
            if (qz && n == n2) {
              continue;
            }
            for (var k = 0; k < 3 + dw5zi; k++) {
              for (var k2 = k + 1; k2 < 4 + dw5zi; k2++) {
                var tmp = [
                  [0, 1],
                  [1, 0],
                ];
                var tmp2 = [peiNumArr[0][n], peiNumArr[1][n2]];
                for (var q = 0; q < tmp.length; q++) {
                  var number = ["X", "X", "X", "X", "X"];
                  number[k] = tmp2[tmp[q][0]];
                  if (dw5zi == 1) number[4] = tmp2[tmp[q][1]];
                  else number[k2] = tmp2[tmp[q][1]];
                  if (createNumberArr.indexOf(number.join("")) == -1)
                    createNumberArr.push(number.join(""));
                }
              }
            }
          }
        }
      } else if (category == 3) {
        for (var n = 0; n < peiNumArr[0].length; n++) {
          for (var n2 = 0; n2 < peiNumArr[1].length; n2++) {
            if (qz && n == n2) {
              continue;
            }
            for (var n3 = 0; n3 < peiNumArr[2].length; n3++) {
              if (qz && (n3 == n2 || n3 == n)) {
                continue;
              }
              for (var k = 0; k < 2; k++) {
                for (var k2 = k + 1; k2 < 3; k2++) {
                  for (var k3 = k2 + 1; k3 < 4; k3++) {
                    var tmp = [
                      [0, 1, 2],
                      [0, 2, 1],
                      [1, 0, 2],
                      [1, 2, 0],
                      [2, 0, 1],
                      [2, 1, 0],
                    ];
                    var tmp2 = [
                      peiNumArr[0][n],
                      peiNumArr[1][n2],
                      peiNumArr[2][n3],
                    ];
                    for (var q = 0; q < tmp.length; q++) {
                      var number = ["X", "X", "X", "X", "X"];
                      number[k + dw5zi] = tmp2[tmp[q][0]];
                      number[k2 + dw5zi] = tmp2[tmp[q][1]];
                      if (dw5zi == 1) number[4] = tmp2[tmp[q][2]];
                      else number[k3 + dw5zi] = tmp2[tmp[q][2]];
                      if (createNumberArr.indexOf(number.join("")) == -1)
                        createNumberArr.push(number.join(""));
                    }
                  }
                }
              }
            }
          }
        }
      } else if (category == 4) {
        for (var n = 0; n < peiNumArr[0].length; n++) {
          for (var n2 = 0; n2 < peiNumArr[1].length; n2++) {
            if (qz && n == n2) {
              continue;
            }
            for (var n3 = 0; n3 < peiNumArr[2].length; n3++) {
              if (qz && (n3 == n2 || n3 == n)) {
                continue;
              }
              for (var n4 = 0; n4 < peiNumArr[3].length; n4++) {
                if (qz && (n3 == n4 || n4 == n2 || n4 == n)) {
                  continue;
                }
                for (var k = 0; k < 1; k++) {
                  for (var k2 = k + 1; k2 < 2; k2++) {
                    for (var k3 = k2 + 1; k3 < 3; k3++) {
                      for (var k4 = k3 + 1; k4 < 4; k4++) {
                        var tmp = [
                          [0, 1, 2, 3],
                          [0, 1, 3, 2],
                          [0, 2, 1, 3],
                          [0, 2, 3, 1],
                          [0, 3, 2, 1],
                          [0, 3, 1, 2],
                          [1, 0, 2, 3],
                          [1, 0, 3, 2],
                          [1, 2, 0, 3],
                          [1, 2, 3, 0],
                          [2, 0, 1, 3],
                          [2, 0, 3, 1],
                          [2, 1, 0, 3],
                          [2, 1, 3, 0],
                          [2, 3, 0, 1],
                          [2, 3, 1, 0],
                          [3, 0, 1, 2],
                          [3, 0, 2, 1],
                          [3, 1, 0, 2],
                          [3, 1, 2, 0],
                          [3, 2, 0, 1],
                          [3, 2, 1, 0],
                        ];
                        var tmp2 = [
                          peiNumArr[0][n],
                          peiNumArr[1][n2],
                          peiNumArr[2][n3],
                          peiNumArr[3][n4],
                        ];
                        for (var q = 0; q < tmp.length; q++) {
                          var number = ["", "", "", "", ""];
                          number[k] = tmp2[tmp[q][0]];
                          number[k2] = tmp2[tmp[q][1]];
                          number[k3] = tmp2[tmp[q][2]];
                          number[k4] = tmp2[tmp[q][3]];

                          number.splice(dw5zi - 1, 0, "X");

                          if (createNumberArr.indexOf(number.join("")) == -1)
                            createNumberArr.push(number.join(""));
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
      return createNumberArr;
    },
    chong(number) {
      number = number.replace(/X/g, "");
      var tmpNumber = {};
      for (var i = 0; i < number.length; i++) {
        if (tmpNumber[number[i]]) {
          tmpNumber[number[i]]++;
        } else {
          tmpNumber[number[i]] = 1;
        }
      }

      var count = 0;
      var ssc = 0;
      for (var key in tmpNumber) {
        if (tmpNumber[key] > count) count = tmpNumber[key];
        if (tmpNumber[key] == 2) ssc++;
      }

      if (ssc == 2) return 5;

      return count;
    },
    brother(number) {
      var tmpNumber = [];
      for (var n = 0; n < number.length; n++) {
        if (number[n] != "X") tmpNumber.push(number[n]);
      }
      tmpNumber = tmpNumber.sort();
      var quchong = [];
      for (var n2 = 0; n2 < tmpNumber.length; n2++) {
        if (quchong.indexOf(tmpNumber[n2]) == -1) quchong.push(tmpNumber[n2]);
      }

      tmpNumber = quchong;

      var count = 0; //9810 0459
      for (var n = 1; n < tmpNumber.length; n++) {
        if (tmpNumber[n] - tmpNumber[n - 1] == 1) count++;
        else if (count > 0) break;
      }

      if (
        (tmpNumber.length == 2 || tmpNumber.length == 3) &&
        tmpNumber[tmpNumber.length - 1] - tmpNumber[0] == 9
      ) {
        count++;
      } else if (tmpNumber.length == 4) {
        if (tmpNumber.join("") == "0189") count = 3;
        else if (
          count == 0 &&
          tmpNumber[tmpNumber.length - 1] - tmpNumber[0] == 9
        )
          count = 1;
        else if (
          tmpNumber[tmpNumber.length - 1] - tmpNumber[0] == 9 &&
          (tmpNumber[1] - tmpNumber[0] == 1 || tmpNumber[3] - tmpNumber[2] == 1)
        )
          count++;
      }

      return count + 1;
    },
  },
};
</script>

<style lang="scss">
.quick-choice-page {
  .create-content {
    table {
      width: 100%;
      max-width: 516px;
      font-size: 12px;
      tr {
        td {
          padding: 5px;
          border-bottom: 1px solid var(--primary-table-border-color);
          &:not(:last-child) {
            border-right: 1px solid var(--primary-table-border-color);
          }
        }
      }
    }
  }
}
</style>

<style lang="scss" scoped>
.quick-choice-page {
  width: 100%;
  display: flex;
  background: var(--new-bg-white);
  input[type="text"] {
    border: 1px solid var(--new-border);
    opacity: 0.7;
  }
  .create-box {
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    flex-shrink: 0;
    width: 500px;
    border: 1px solid var(--new-border);
    height: 550px;
    .title {
      line-height: 35px;
      height: 35px;
      background: var(--new-bg-table-header-main);
      text-align: center;
      color: var(--new-text);
      font-size: 13px;
    }
    .create-content {
      overflow-y: auto;
      flex: 1;
    }
    .bottom-tool {
      padding-left: 20px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 35px;
      border-top: 1px solid var(--new-border);
      font-size: 13px;
      .left,
      .right {
        display: flex;
        align-items: center;
      }
      .bold {
        font-weight: bold;
      }
      .money {
        margin-right: 20px;
        width: 98px;
        height: 22px;
        border: 1px solid var(--new-border);
      }
      .submit {
        margin-right: 25px;
        width: 60px;
        height: 20px;
        background: linear-gradient(90deg, #54aff3, #2992e1, #1082d7);
        border-radius: 2px;
        color: #fff;
      }
      .totalNum,
      .totalMoney {
        margin: 0 5px;
        min-width: 30px;
      }
    }
  }
  .tool-panel {
    flex: 1;
    font-size: 14px;
    // border: 1px solid #BAD4E8;
    input[type="checkbox"] {
      // transform: translateY(2px);
    }
    // border: 1px solid var(--primary-table-border-color);
    .nav {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      font-size: 13px;
      font-weight: bold;
      li {
        width: 100px;
        width: 33.3%;
        height: 35px;
        text-align: center;
        line-height: 35px;
        cursor: pointer;
        border: 1px solid var(--new-border);
        border-right: none;
        color: var(--new-text);
        background: var(--new-bg-table-header-main);
        &:last-child {
          border-right: 1px solid var(--new-border);
        }
        &.active {
          color: var(--new-text-active);
        }
      }
    }
    table {
      // border: 1px solid var(--new-border);
      background: #fff;
      font-size: 12px;
      // tr {
      //   border: 1px solid var(--primary-table-border-color);
      // }
      td {
        height: 28px;
        line-height: 28px;
        padding: 3px;
        padding-left: 10px;
        border-bottom: 1px solid var(--new-border);
      }
      .btn-group {
        padding: 12px;
        text-align: center;
        input[type="button"] {
          margin-right: 40px;
        }
      }
    }
  }
}
</style>
